import { useSelector } from 'react-redux'
import { RootState } from '@/redux'
import { PageTitle } from '@/components/custom/PageTitle'
import { BillingHub } from '@/pages/Dashboard/components/BillingHub'
import { DashboardDetailTabs } from '@/pages/Dashboard/components/DashboardDetailTabs'
import { MRRCharts } from './components/MRRCharts'

export const Dashboard = () => {
  const { userData } = useSelector((state: RootState) => state.user)

  if (!userData?.isTCSAdmin) {
    return (
      <div className="protectedPageLayout">
        <PageTitle title="Dashboard" />
        <div className="mt-8 rounded-lg border border-red-200 bg-red-50 p-6">
          <h2 className="mb-2 text-lg font-semibold text-red-800">Access denied</h2>
          <p className="text-red-600">Only TCS Administrators can access the Dashboard.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="protectedPageLayout w-full min-h-screen bg-slate-100">
      <div className="pt-0.5 pb-8 w-full">
        <PageTitle title="Dashboard" hasSubtitle />
        <p className="big-textArea text-secondary text-left text-base font-normal leading-5 mb-10">
          Billing overview and platform management.
        </p>

        <div className='mb-5'>
          <MRRCharts />
        </div>

        <div className="mb-5">
          <BillingHub />
        </div>
        <div aria-label="Detail tables and metrics">
          <DashboardDetailTabs />
        </div>
      </div>
    </div>
  )
}
